import Controller from '@ember/controller';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { type RecommendationItem } from 'scaleflow/routes/recommendations';

export default class RecommendationsController extends Controller {
  queryParams = ['activeTab'];
  @tracked activeTab = 'all';

  declare model: RecommendationItem[];

  get tabs() {
    return [
      {
        label: 'All',
        value: 'all',
        count: this.model.length,
      },
      {
        label: 'Actions',
        value: 'action',
        count: this.model.filter((item) => item.type === 'action').length,
      },
      {
        label: 'Insights',
        value: 'insight',
        count: this.model.filter((item) => item.type === 'insight').length,
      },
      {
        label: 'Mentions',
        value: 'mention',
        count: this.model.filter((item) => item.type === 'mention').length,
      },
    ];
  }

  get items() {
    if (this.activeTab === 'all') return this.model;
    else return this.model.filter((item) => item.type === this.activeTab);
  }

  @action
  setActiveTab(tab: string) {
    this.activeTab = tab;
  }
}
